export const CURRENT_ROLE_CUSTOMER_BASED = ()=>{
  let currentCustomer = window.location.origin.includes("greece") ? "greece" : "demo"; //Hardcode here to change the local role for dev
  switch (currentCustomer) {
      case "greece":
        return {
          // "DEVELOPER" : "DISTRICT_ADMIN"
        };
        case "gcsd":
          return {
            // "DEVELOPER" : "DISTRICT_ADMIN"
          };
      case "demo":
        return {
          "DEVELOPER" : "DEVELOPER"
        };
    }
}


export const CURRENT_CUSTOMER = ()=>{
    return window.location.origin.includes("greece") ? "greece" : "demo"
}

// Hardcode to true here to simulate k12360 behaviour locally
export const IS_K12 = window.location.origin.includes('https://k12360.innive.io');

// Hardcode to true here to simulate demo.k12360.innive.io behaviour locally
// export const IS_DEMO_K12 =['http://localhost:3000', 'demo.k12360.innive.io'].includes(window.location.origin);
export const IS_DEMO_K12 = window.location.origin.includes("demo.k12360.innive.io");

const RHCSD_MIDDLE_CARD_ORIGINS = [
  "https://rhcsd.k12360-pilot.innive.io",
  "https://rhcsd.k12360.innive.io",
];

// Restrict Tutorial/FAQ-only middle-card layout to the approved RHCSD hosts.
export const IS_RHCSD_MIDDLE_CARD_LAYOUT = RHCSD_MIDDLE_CARD_ORIGINS.includes(
  window.location.origin
);

// Hardcode here to override for local dev, e.g. "Landing_Page_Application_Links_demo"
export const APP_LINKS_REPORT = IS_DEMO_K12
  ? "Landing_Page_Application_Links"
  : "Landing_Page_Application_Links";